module.exports = __webpack_public_path__ + "static/media/Entreprise-Expertise-Immobiliere-Vaud.4a5f2670.jpg";